// extracted by mini-css-extract-plugin
export var actions = "_c5-g";
export var benefitCard = "_c5-b";
export var benefitIcon = "_c5-d";
export var benefitLabel = "_c5-f";
export var benefits = "_c5-a";
export var benefitsSection = "_c5-8";
export var bodyText = "_c5-7";
export var closeButton = "_c5-2";
export var content = "_c5-3";
export var eyebrow = "_c5-4";
export var heading = "_c5-5";
export var image = "_c5-i";
export var imagePanel = "_c5-h";
export var modal = "_c5-0";
export var offerCard = "_c5-c";
export var offerIcon = "_c5-e";
export var sectionLabel = "_c5-9";
export var shell = "_c5-1";
export var title = "_c5-6";